import advs from '../../data/advs';
import { Advs, Adv } from '../../domain/adv';
import { AdvFluidType } from '../../domain/graphcms';

export async function getAdvs(): Promise<Advs> {
  return advs;
}

export async function getAdvByType(type: AdvFluidType): Promise<Adv> {
  return advs[type];
}

export function getAdvByTypeSync(type: AdvFluidType): Adv {
  return advs[type];
}
